// src/api/product.js
import request from '@/utils/request'; // 导入配置好的 Axios 实例

export const getAllProducts = () => {
  return request({
    url: '/product/getAll',
    method: 'get',
  });
};

export const getProductAllPropertiesById = (productId) => {
  return request({
    url: '/product/getAllPropertyById',
    method: 'get',
    params: { productId }, // 使用 params 传递查询参数
  });
};

export const addProduct = (data) => {
  return request({
    url: '/product/add',
    method: 'post',
    data, // post 请求体数据
  });
};

export const editProduct = (data) => {
  return request({
    url: '/product/editProperty',
    method: 'post',
    data,
  });
};

export const onIndex = (data) => {
  return request({
    url: '/product/onIndex',
    method: 'post',
    data,
  });
};

export const offIndex = (data) => {
  return request({
    url: '/product/offIndex',
    method: 'post',
    data,
  });
};

export const changeProductSort = (data) => {
  return request({
    url: '/product/allSort',
    method: 'post',
    data,
  });
};

export const deleteProduct = (productId) => {
  // 注意：如果后端要求 POST 且 ID 在路径中，这样写是对的
  // 如果是 DELETE 请求，则 method: 'delete'
  // 如果 ID 是在请求体中，则 data: { productId }
  return request({
    url: `/product/delete/${productId}`,
    method: 'post', // 或 'delete'
  });
};